<template>
  <div id="index">
    <el-container>
      <el-container>
        <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
          <el-main>
            <nav-bar></nav-bar>
            <el-form
              ref="formselect"
              v-model="formselect"
              class="queryform_div"
              label-width="100px"
            >
              <el-row :gutter="24">
                <el-col :md="8" :xs="24" :sm="24">
                  <el-form-item :label="$t('desc.keyword')">
                    <el-input
                      size="small"
                      style="width: 100%"
                      v-model="formselect.keyword"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :md="6" :xs="24" :sm="24" style="margin-top: 10px">
                  <el-button @click="getData('search')" type="primary" size="small"
                    >{{ $t("button.query") }}
                  </el-button>
                  <el-button @click="reset" size="small"
                    >{{ $t("button.reset") }}
                  </el-button>
                </el-col>
              </el-row>
            </el-form>
            <template>
              <el-button
                v-if="hasCreateAuth"
                type="primary"
                icon="el-icon-circle-plus-outline"
                @click="openDialog('add')"
                style="margin-bottom: 10px"
                >{{ $t("button.add") }}
              </el-button>
              <div class="tableDiv">
                <el-table
                  :data="tableData1"
                  stripe
                  style="width: 100%"
                  v-loading="loading"
                  :empty-text="$t('desc.noData')"
                >
                  <el-table-column
                    type="index"
                    :label="$t('title.serialNumber')"
                    width="60"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="bnDictCode"
                    :label="$t('desc.english')"
                    min-width="150px"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="bnDictName"
                    :label="$t('desc.chinese')"
                    min-width="100px"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('title.operate')"
                    width="120"
                    fixed="right"
                    v-if="hasDeleteAuth || hasUpdateAuth"
                  >
                    <template slot-scope="scope">
                      <el-button
                        v-if="hasUpdateAuth"
                        type="primary"
                        icon="el-icon-edit"
                        :title="$t('button.update')"
                        circle
                        size="mini"
                        @click="openDialog('edit', scope.row)"
                      ></el-button>
                      <template v-if="hasDeleteAuth">
                        <el-popconfirm
                          placement="top"
                          :confirmButtonText="$t('button.delete')"
                          :cancelButtonText="$t('button.cancel')"
                          icon="el-icon-info"
                          iconColor="red"
                          :title="$t('title.confirmDelete')"
                          @confirm="deleteTranslation(scope.row.id)"
                        >
                          <el-button
                            type="danger"
                            icon="el-icon-delete"
                            :title="$t('button.delete')"
                            circle
                            size="mini"
                            slot="reference"
                          ></el-button>
                        </el-popconfirm>
                      </template>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  background
                  :page-sizes="[10, 20, 50]"
                  layout="prev, pager, next, sizes"
                  :total="pagination.totalPage"
                  :current-page.sync="pagination.current"
                  :page-size="pagination.pageSize"
                  @current-change="pageChange()"
                  @size-change="handleSizeChange"
                  style="text-align: center; margin-top: 10px"
                ></el-pagination>
              </div>
            </template>
          </el-main>
        </el-scrollbar>
      </el-container>
    </el-container>

    <el-dialog
      :title="dialogType == 'add' ? $t('button.add') : $t('button.update')"
      v-if="dialogAdd"
      :visible.sync="dialogAdd"
      width="60%"
      top="5vh"
    >
      <el-form ref="addform" :model="addform" label-width="200px" :rules="addRule">
        <el-form-item
          :label="$t('desc.english')"
          prop="bnDictCode"
          :rules="[{ required: true, message: $t('tips.needed') }]"
        >
          <el-input
            v-model="addform.bnDictCode"
            :disabled="dialogType != 'add'"
            style="width: 200px"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('desc.chinese')"
          prop="bnDictName"
        >
          <el-input
            v-model="addform.bnDictName"
            style="width: 200px"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="onSubmit">{{
            $t("button.confirm")
          }}</el-button>
          <el-button @click="dialogAdd = false">{{
            $t("button.cancel")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  authOperationCheck,
  getAlarmTranslations,
  updateAlarmTranslation,
  createAlarmTranslation,
  deleteAlarmTranslation
} from "../../api/api";

export default {
  name: "customerAccount",

  computed: mapState({
    isCollapse: (state) => state.isCollapse,
  }),
  data() {
    return {
      dialogAdd: false,
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      addRule: {
        bnDictCode: [
          { required: true, message: this.$t("tips.needed"), trigger: "blur" },
        ],
      },
      formselect: {
        keyword: "",
      },
      addform:{
        bnDictCode:"",
        bnDictName:"",
      },
      dialogType:"",
      tableData1: [],
      loading: false,
      hasCreateAuth: false,
      hasUpdateAuth: false,
      hasDeleteAuth: false,
    };
  },
  mounted() {
    this.authoperation("AlarmTranslation");
    this.getData();
  },
  methods: {
    authoperation(curPage) {
      let that = this;
      let res = authOperationCheck(curPage);
      that.hasCreateAuth = res.hasCreateAuth;
      that.hasUpdateAuth = res.hasUpdateAuth;
      that.hasDeleteAuth = res.hasDeleteAuth;
      that.hasResetPasswordAuth = res.hasResetPasswordAuth;
    },
    async getData(type = "normal"){
      this.loading = true;
      if (type == "search") {
        this.pagination.current = 1;
      }
      let data = {
        Keyword: this.formselect.keyword,
        skipCount: (this.pagination.current - 1) * this.pagination.pageSize,
        maxResultCount: this.pagination.pageSize
      };
      try {
        let res = await getAlarmTranslations(data);
        this.loading = false;
        this.tableData1 = res.result.items;
        this.pagination.totalPage = res.result.totalCount;
      } catch (error) {
        this.loading = false;
      }
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getData();
    },
    pageChange() {
      this.getData();
    },
    reset() {
      this.formselect.keyword = "";
      this.getData('search');
    },
    openDialog(dialogType, row){
      this.addform = {}
      this.dialogAdd = true;
      this.dialogType = dialogType;
      if (row) {
        this.addform = row;
      }
    },
    async edit(){
      try {
        let res = await updateAlarmTranslation(this.addform);
        this.$message({
          showClose: true,
          message: this.$t("tips.saveSuccess"),
          type: "success",
        });
        this.dialogAdd = false;
        this.getData();
      } catch (err) {
        this.$message({
          showClose: true,
          message: err.error.message,
          type: "error",
        });
      }
    },
    async add(){
      try {
        let res = await createAlarmTranslation(this.addform);
        this.$message({
          showClose: true,
          message: this.$t("tips.saveSuccess"),
          type: "success",
        });
        this.dialogAdd = false;
        this.getData();
      } catch (err) {
        let msg = err.error.message;
        if (msg.indexOf("添加失败") > -1) {
          msg = this.$t("errorMsg.addFailAlarmTranslation")
        }
        this.$message({
          showClose: true,
          message: msg,
          type: "error",
        });
      }
    },
    async onSubmit(){
      this.$refs["addform"].validate((valid) => {
        if (valid) {
          if (this.dialogType == "add") {
            this.add();
          } else {
            this.edit();
          }
        } else {
          return false;
        }
      });
    },
    async deleteTranslation(id){
      try {
        let res = await deleteAlarmTranslation(id);
        this.$message.success(this.$t("tips.deleteSuccess"));
        this.getData();
      } catch (err) {
        this.$message({
          showClose: true,
          message: err.error.message,
          type: "error",
        });
      }
      
    },
  },
};
</script>


